"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerStyle = exports.fontStyle = exports.retinaImage = exports.maxWidth = exports.minWidth = void 0;

var _styledComponents = require("styled-components");

var _Layout = _interopRequireDefault(require("../Theme/Layout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var minWidth = Object.keys(_Layout["default"]).reduce(function (accumulator, label) {
  var emSize = _Layout["default"][label] / 16;

  accumulator[label] = function () {
    return (0, _styledComponents.css)(["@media (min-width:", "em){", ";}"], emSize, _styledComponents.css.apply(void 0, arguments));
  };

  return accumulator;
}, {});
exports.minWidth = minWidth;
var maxWidth = Object.keys(_Layout["default"]).reduce(function (accumulator, label) {
  var emSize = _Layout["default"][label] / 16;

  accumulator[label] = function () {
    return (0, _styledComponents.css)(["@media (max-width:", "em){", ";}"], emSize, _styledComponents.css.apply(void 0, arguments));
  };

  return accumulator;
}, {});
exports.maxWidth = maxWidth;

var retinaImage = function retinaImage(one, two) {
  return (0, _styledComponents.css)(["background-image:url(", ");background-size:cover;background-repeat:no-repeat;@media (-webkit-min-device-pixel-ratio:2),(min-resolution:192dpi){background-image:url(", ");}"], one, two);
};

exports.retinaImage = retinaImage;

var fontStyle = function fontStyle(size, weight, family) {
  return (0, _styledComponents.css)(["font-size:", "rem;line-height:", "rem;", " ", ""], size, size + 0.8, weight && "font-weight: ".concat(weight, ";"), family && "font-family: ".concat(family, ";"));
};

exports.fontStyle = fontStyle;

var headerStyle = function headerStyle(size) {
  return (0, _styledComponents.css)(["font-size:", "rem;line-height:", "rem;text-transform:uppercase;font-weight:700;"], size, size + 0.5);
};

exports.headerStyle = headerStyle;